export interface IMBPFields {
  PERIOD_FIlTER_FROM: string;
  PERIOD_FIlTER_TO: string;
}

export const fields: IMBPFields = {
  PERIOD_FIlTER_TO: "periodTo",
  PERIOD_FIlTER_FROM: "periodFrom",
};
